var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportListe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02944 0 0 4.02944 0 9V63C0 67.9704 4.02944 72 9 72H63C67.9704 72 72 67.9704 72 63V9C72 4.02944 67.9704 0 63 0H9ZM23 21C23 23.2091 21.2091 25 19 25C16.7909 25 15 23.2091 15 21C15 18.7909 16.7909 17 19 17C21.2091 17 23 18.7909 23 21ZM30 21C30 19.3432 31.3432 18 33 18H55C56.6568 18 58 19.3432 58 21C58 22.6568 56.6568 24 55 24H33C31.3432 24 30 22.6568 30 21ZM30.0004 36C30.0004 34.3432 31.3432 33 33.0004 33H54.9996C56.6568 33 57.9996 34.3432 57.9996 36C57.9996 37.6568 56.6568 39 54.9996 39H33.0004C31.3432 39 30.0004 37.6568 30.0004 36ZM33.0004 48H54.9996C56.6568 48 57.9996 49.3432 57.9996 51C57.9996 52.6568 56.6568 54 54.9996 54H33.0004C31.3432 54 30.0004 52.6568 30.0004 51C30.0004 49.3432 31.3432 48 33.0004 48ZM19 40C16.7909 40 15 38.2092 15 36C15 33.7908 16.7909 32 19 32C21.2091 32 23 33.7908 23 36C23 38.2092 21.2091 40 19 40ZM23 51C23 53.2092 21.2091 55 19 55C16.7909 55 15 53.2092 15 51C15 48.7908 16.7909 47 19 47C21.2091 47 23 48.7908 23 51Z",
    fill: "#271CA9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_340_315)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_340_315",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 36,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 36.5H67.5V67.5H36.5V36.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_340_315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 67C60.2843 67 67 60.2843 67 52C67 43.7157 60.2843 37 52 37C43.7157 37 37 43.7157 37 52C37 60.2843 43.7157 67 52 67Z",
    fill: "white",
    stroke: "#C727FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8184 51.5633L52.5194 57.2644C52.6171 57.362 52.6171 57.5203 52.5194 57.6179L52.1659 57.9715C52.0682 58.0691 51.9099 58.0691 51.8123 57.9715L46.1113 52.2704C46.0136 52.1728 46.0136 52.0145 46.1113 51.9169L46.4648 51.5633C46.5625 51.4657 46.7207 51.4657 46.8184 51.5633Z",
    fill: "#0D6EFD",
    stroke: "#C727FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.909 52.2282L52.208 57.9293C52.1103 58.0269 51.952 58.0269 51.8544 57.9293L51.5009 57.5757C51.4032 57.4781 51.4032 57.3198 51.5009 57.2222L57.2019 51.5211C57.2995 51.4235 57.4578 51.4235 57.5555 51.5211L57.909 51.8747C58.0066 51.9723 58.0066 52.1306 57.909 52.2282Z",
    fill: "#0D6EFD",
    stroke: "#C727FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7703 45.3474H52.2703C52.4083 45.3474 52.5203 45.4593 52.5203 45.5974V54.3474C52.5203 54.4854 52.4083 54.5974 52.2703 54.5974H51.7703C51.6322 54.5974 51.5203 54.4854 51.5203 54.3474V45.5974C51.5203 45.4593 51.6322 45.3474 51.7703 45.3474Z",
    fill: "#0D6EFD",
    stroke: "#C727FF",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_340_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(36 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportListe);
export default __webpack_public_path__ + "static/media/exportListe.d4742b58cc1042514de7f252384c0324.svg";
export { ForwardRef as ReactComponent };